import React, { useState, useEffect } from "react";
import AstroManthan from "../assets/images/Astro Manthan.webp";
import AutoFinance from "../assets/images/Auto Finance.webp";
import BDCGrid from "../assets/images/BDC Grid.webp";
import BrixwellGroup from "../assets/images/Brixwell Group.webp";
import BrothersIndustries from "../assets/images/Brothers Industries.webp";
import CrustCravings from "../assets/images/Crust cravings.webp";
import DoubleUpRealty from "../assets/images/Double Up Realty.webp";
import EktekBiocare from "../assets/images/Ektek Biocare.webp";
import FidelityHealthcare from "../assets/images/Fidelity Healthcare.webp";
import FinTaxGo from "../assets/images/FinTaxGo.webp";
import GausevaSociety from "../assets/images/Gauseva Society.webp";
import GlareSocial from "../assets/images/Glare Social.webp";
import HexHive from "../assets/images/HexHive.webp";
import HomeyMeals from "../assets/images/Homey Meals.webp";
import Inanna from "../assets/images/Inanna.webp";
import IndustrialSaleCorporation from "../assets/images/Industrial Sale Corporation.webp";
import KDFPPvtLtd from "../assets/images/KDFP Pvt. Ltd..webp";
import KGCIndustries from "../assets/images/KGC Industries.webp";
import Kanidar from "../assets/images/Kanidar.webp";
import KaramHospital from "../assets/images/Karam Hospital.webp";
import KesariBagh from "../assets/images/Kesari Bagh.webp";
import LifeRedesigned from "../assets/images/Life Redesigned.webp";
import Musclife from "../assets/images/Musclife.webp";
import NirvanaDisabilitySupport from "../assets/images/Nirvana Disability Support.webp";
import OjalFasteners from "../assets/images/Ojal Fasteners.webp";
import PalatialStudios from "../assets/images/Palatial Studios.webp";
import RinoxGmbh from "../assets/images/Rinox Gmbh.webp";
import SanjhaChullah from "../assets/images/Sanjha Chullah.webp";
import ShivaTuff from "../assets/images/Shiva Tuff.webp";
import TheBespokeHouse from "../assets/images/The Bespoke House.webp";
import VishwGuru from "../assets/images/Vishw Guru.webp";
import Image5h from "../assets/images/5h.webp";
import { Link } from "react-router-dom";

const Portfolio = () => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  const handlePopupOpen = (e) => {
    e.preventDefault();
    setIsPopupVisible(true);
  };

  const handlePopupClose = (e) => {
    e.preventDefault();
    setIsPopupVisible(false);
  };

  const projects = [
    { title: "Palatial Studios", image: PalatialStudios, link: "https://palatialstudios.com/" },
    { title: "Brothers Industries", image: BrothersIndustries, link: "https://brothersinds.com/" },
    { title: "Karam Hospital", image: KaramHospital, link: "https://karamhospital.com/" },
    { title: "Gauseva Society", image: GausevaSociety, link: "https://donate.gausevasociety.com/donations" },
    { title: "Vishw Guru", image: VishwGuru, link: "https://vishwguru.com/" },
    { title: "KDFP Pvt. Ltd.", image: KDFPPvtLtd, link: "https://kdfppvtltd.com/" },
    { title: "Kanidar", image: Kanidar, link: "https://kanidar.com/" },
    { title: "HexHive", image: HexHive, link: "https://hexhive.in/" },
    { title: "FinTaxGo", image: FinTaxGo, link: "https://fintaxgo.com/" },
    { title: "Astro Manthan", image: AstroManthan, link: "https://astromanthan.co.in/" },
    { title: "Glare Social", image: GlareSocial, link: "https://glaresocial.com/" },
    { title: "Inanna", image: Inanna, link: "https://inanna.co.in/" },
    { title: "Ektek Biocare", image: EktekBiocare, link: "https://ektekbiocare.com/" },
    { title: "KGC Industries", image: KGCIndustries, link: "https://kgcindustries.com/" },
    { title: "Industrial Sale Corporation", image: IndustrialSaleCorporation, link: "https://industrialsalecorp.com/" },
    { title: "Ojal Fasteners", image: OjalFasteners, link: "https://ojalfasteners.com/" },
    { title: "Brixwell Group", image: BrixwellGroup, link: "https://brixwellgroup.com/" },
    { title: "Kesari Bagh", image: KesariBagh, link: "https://thekesaribagh.com/" },
    { title: "5h", image: Image5h, link: "https://5h.ae/" },
    { title: "Shiva Tuff", image: ShivaTuff, link: "https://shivatuff.in/index.html" },
    { title: "Rinox Gmbh", image: RinoxGmbh, link: "https://rinox-gmbh.de/" },
    { title: "Crust cravings", image: CrustCravings, link: "https://crustncravings.com/" },
    { title: "Homey Meals", image: HomeyMeals, link: "https://homeymeals.com.au/tiffin_order" },
    { title: "Double Up Realty", image: DoubleUpRealty, link: "https://doubleuprealty.com/" },
    { title: "BDC Grid", image: BDCGrid, link: "https://bdcgrid.com/" },
    { title: "Nirvana Disability Support", image: NirvanaDisabilitySupport, link: "https://nirvanadisabilitysupport.com/" },
    { title: "The Bespoke House", image: TheBespokeHouse, link: "https://thebespokehouse.in/" },
    { title: "Auto Finance", image: AutoFinance, link: "https://autofinancehub.ca/" },
    { title: "Fidelity Healthcare", image: FidelityHealthcare, link: "https://fidelityhealthcare.co.nz/" },
    { title: "Life Redesigned", image: LifeRedesigned, link: "https://liferedesigned.co.in/" },
    { title: "Musclife", image: Musclife, link: "https://musclife.com/" },
    { title: "Sanjha Chullah", image: SanjhaChullah, link: "https://sanjhachullah.com.au/" }
  ];

  const [showAll, setShowAll] = useState(false);
  const visibleProjects = showAll ? projects : projects.slice(0, 6);

  const handleViewAll = (e) => {
    e.preventDefault();
    setShowAll(!showAll);
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("show");
        } else {
          entry.target.classList.remove("show");
        }
      });
    });

    const hiddenElements = document.querySelectorAll(
      ".fade_up, .fade_down, .zoom_in, .zoom_out, .fade_right, .fade_left, .flip_left, .flip_right, .flip_up, .flip_down"
    );
    hiddenElements.forEach((el) => observer.observe(el));

    // Event listener to toggle 'full' class on image click
    const handleImageClick = (event) => {
      event.target.classList.toggle("full");
    };

    // Attach click event to gallery images
    const galleryLinks = document.querySelectorAll(".gallery-link img");
    galleryLinks.forEach((link) => {
      link.addEventListener("click", handleImageClick);
    });

    return () => {
      hiddenElements.forEach((el) => observer.unobserve(el));
      galleryLinks.forEach((link) => {
        link.removeEventListener("click", handleImageClick);
      });
    };
  }, [visibleProjects]);
  return (
    <>
      {/* <!-- ====================================== Section Portfolio ===================================== --> */}
      <section className="portfolio-section" id="portfolio">
        <div className="heading-container">
          <h2 className="section-heading-text coding-skill-text fade_up">
            Portfolio.
          </h2>
          <div className="line"></div>
        </div>
        <div className="portfolios-group-main">
          {visibleProjects.map((project, index) => (
            <div key={index} className="zoom_in">
              <a href={project.link} target="_blank" rel="noopener noreferrer" className="image-container">
                <img src={project.image} alt={project.title} />
                <div className="overlay">
                  <p className="overlay-text">{project.title}</p>
                </div>
              </a>
              <p className="Corporate">{project.title}</p>
              <p className="Corporate-sub">Website</p>
            </div>
          ))}
        </div>
        <div className="wrapper view-all-btn zoom_in">
          <Link className="btn-hover" to="#" onClick={handleViewAll}>
            {showAll ? "Show Less" : "View All"}
          </Link>
        </div>
      </section>
    </>
  );
};
export default Portfolio;
